import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import FaqSeo from "../components/FaqSeo";

function FaqAccordion() {
  const [faqs, setFaqs] = useState([]);
  const { slug } = useParams();

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL +"/faqs")
      .then((res) => res.json())
      .then((data) => setFaqs(Array.isArray(data) ? data : []))
      .catch(console.error);
  }, []);

  // ✅ filter by category slug
  const filteredFaqs = useMemo(() => {
    if (!slug) return faqs;
    return faqs.filter((cat) => cat.slug === slug);
  }, [faqs, slug]);

  return (
    <>
      <FaqSeo faqs={filteredFaqs} />
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white">FAQs</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h6 className="section-title bg-white text-center icon-color px-3">
              <span className="footer-color">FAQs</span>
            </h6>
            <h1 className="mb-4">Frequently Asked Questions</h1>
          </div>

          {filteredFaqs.map((cat) => (
            <div key={cat.slug} className="mb-4">
              {/* ✅ CATEGORY LINK */}
              <h4 className="mb-3">
                <Link
                  to={`/faqs/${cat.slug}`}
                  className="text-decoration-none icon-color"
                >
                  {cat.category}
                </Link>
              </h4>

              <div className="accordion" id={`accordion-${cat.slug}`}>
                {(cat.faqs || []).map((faq) => (
                  <div className="accordion-item" key={faq.id}>
                    <h2
                      className="accordion-header"
                      id={`heading-${faq.id}`}
                    >
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${faq.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse-${faq.id}`}
                      >
                        {faq.question}
                      </button>
                    </h2>

                    <div
                      id={`collapse-${faq.id}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading-${faq.id}`}
                      data-bs-parent={`#accordion-${cat.slug}`}
                    >
                      <div className="accordion-body">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default FaqAccordion;